<div data-test="jxj_xCrj" class="sidebar-modules scrollbar-hidden" data-simplebar>
  <div
    data-test="sMSXVReY"
    class="simplebar-scroll-content"
    style="padding-right: 17px; margin-bottom: -34px"
  >
    <div
      data-test="5PFwjC8W"
      class="simplebar-content"
      style="padding-bottom: 17px; margin-right: -17px"
    >
      <div data-test="LvbTzbKT" class="sidebar-modules__wrap">
        <div data-test="4L8Z8I3G" class="sidebar-modules__container">
          <div
            data-test="nwL_weI2"
            class="sidebar-modules__company sidebar-modules__link"
            [mdPopover]="userPermissions.OBJECTS_COMPANY_EDIT ? companyMenu : ''"
            data-dropdown="#dd-company"
            *ngIf="currentCompany$ | async | notNull as currentCompany"
          >
            <md-letter-image
              data-test="SrJhytcl"
              class="img-square img-square_md"
              [name]="currentCompany.name"
              [image]="currentCompany.logo"
            ></md-letter-image>
            <span
              data-test="sidebar-company-name"
              class="sidebar-modules__transition"
              #companyName
            >
              {{ currentCompany.name }}
            </span>
            <i
              *ngIf="userPermissions.OBJECTS_COMPANY_EDIT"
              data-test="u1LeH9iD"
              class="sidebar-modules__transition material-icons md-12"
            >
              keyboard_arrow_down
            </i>
            <div
              data-test="rzo5Yjf0"
              class="dropdown dropdown_arrow"
              [ngClass]="[
                companyName.offsetWidth > 80
                  ? 'dropdown_bottom-right'
                  : 'dropdown_bottom-middle'
              ]"
              #companyMenu
            >
              <div data-test="bYXlXZlP" class="dropdown__wrap">
                <ul data-test="k7lwqSt0" class="dropdown__menu">
                  <li data-test="AqP1-101" class="dropdown__menu-item">
                    <a
                      data-test="uQF2ym9K"
                      class="dropdown__menu-link"
                      [routerLink]="['/company-management/settings']"
                    >
                      Company settings
                    </a>
                  </li>
                  <!-- <li *ngIf="userCompanies?.length" (mousedown)="showCompanySwithcer()" class="dropdown__menu-item">
                    <a class="dropdown__menu-link">Switch company</a>
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
          <a data-test="S7rMvl0O" class="sidebar-modules__link" (click)="switchModule()">
            <ng-container [ngSwitch]="module">
              <svg
                data-test="d2vURb0O"
                *ngSwitchCase="ModuleNames.COMPANY_MANAGEMENT"
                class="icon__icon-companies"
                width="12px"
                height="12px"
              >
                <use xlink:href="#icon-companies"></use>
              </svg>
              <svg
                data-test="YQ1920oQ"
                *ngSwitchCase="ModuleNames.HUMAN_RESOURCES"
                class="icon__icon-hr"
                width="18px"
                height="18px"
              >
                <use xlink:href="#icon-hr"></use>
              </svg>
              <svg
                data-test="Fk527yYb"
                *ngSwitchCase="ModuleNames.TIME_TRACKING"
                class="icon__icon-planner"
                width="18px"
                height="16px"
              >
                <use xlink:href="#icon-planner"></use>
              </svg>
            </ng-container>
            <span
              data-test="rnQnQMQ4"
              class="sidebar-modules__transition sidebar-modules__transition_hover"
            >
              {{ module }}
            </span>
            <button
              data-test="dJPpFdA7"
              class="sidebar-modules__button button button_primary button_xs"
            >
              Change module
            </button>
          </a>
          <div data-test="fm5iJIxa" class="modules-nav">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
